import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { LazySelectable, lazySelector, prefersReducedMotion } from '@sg-core/resources/assets/js/utils';

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

export interface AnimateOptions extends Record<string, unknown> {
  bypassPrefersReducedMotion?: boolean;
}

export class Animate {
  protected el: HTMLElement;
  protected options: AnimateOptions;

  constructor(element: LazySelectable, options: AnimateOptions = {}) {
    this.el = lazySelector(element);

    this.options = {
      ...{
        bypassPrefersReducedMotion: false,
      },
      ...options,
    };

    if (!prefersReducedMotion() || this.options.bypassPrefersReducedMotion) {
      this.register();
    }
  }

  /**
   * Registers the Gsap animation timeline
   */
  register() {
    // noop
  }
}
